var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIndicator2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.909 2.364 16 6.454l4.091-4.09M11.909 29.636 16 25.545l4.091 4.09M2.145 12.725l5.588-1.498L6.236 5.64M25.764 26.36l-1.497-5.587 5.588-1.498M29.855 12.725l-5.588-1.498 1.497-5.588M6.236 26.36l1.497-5.587-5.588-1.498M16 1v30M3.01 8.5l25.98 15M28.99 8.5l-25.98 15",
  stroke: "#7465EB",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
})));
export default SvgIndicator2;